import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28532cf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Rider Rate Edit")
  ])
], -1))
const _hoisted_4 = { class: "col-5 mt-4" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Miles" }, "Miles", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Km" }, "Kilometers", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Distance Type", -1))
const _hoisted_10 = { class: "form-floating" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Per Unit Price", -1))
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Base Price", -1))
const _hoisted_14 = { class: "form-floating" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Base Unit", -1))
const _hoisted_16 = { class: "form-floating" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Additional Per order Price", -1))
const _hoisted_18 = { class: "form-floating" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Additional Per order Same Client Price", -1))
const _hoisted_20 = { class: "form-floating" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Additional Per order Diff Client Price", -1))
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Base Rate ", -1))
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Reference Rate ", -1))
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Advance Rate ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.distance_type) = $event)),
              class: "form-control",
              required: ""
            }, _hoisted_8, 512), [
              [_vModelSelect, $setup.data.distance_type]
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.per_unit_price) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Per Unit Price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.per_unit_price]
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.base_price) = $event)),
              class: "form-control",
              placeholder: "Base Price",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.base_price]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.base_unit) = $event)),
              class: "form-control",
              placeholder: "Base Unit",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.base_unit]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.aditional_per_order_price) = $event)),
              class: "form-control",
              placeholder: "Additional Per order Price"
            }, null, 512), [
              [_vModelText, $setup.data.aditional_per_order_price]
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.aditional_order_same_client) = $event)),
              class: "form-control",
              placeholder: "Additional Per order Price"
            }, null, 512), [
              [_vModelText, $setup.data.aditional_order_same_client]
            ]),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.aditional_order_diff_client) = $event)),
              class: "form-control",
              placeholder: "Additional Per order Price"
            }, null, 512), [
              [_vModelText, $setup.data.aditional_order_diff_client]
            ]),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.is_base_rate) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_base_rate]
            ]),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.is_reference_rate) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_reference_rate]
            ]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.is_advance_rate) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_advance_rate]
            ]),
            _hoisted_27
          ]),
          _hoisted_28
        ], 32)
      ])
    ])
  ]))
}